// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"recommended-products-element_wrapper__tEnaa","wrapper--compact":"recommended-products-element_wrapper--compact__1H1gx"};